import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

$('.play-btn').magnificPopup({
  type: 'iframe',
  mainClass: 'mfp-fade',
  removalDelay: 300,
  callbacks: {
    elementParse: function (item) {
      // 動画のURLをiframeのsrcに設定
      item.src = item.el.attr('data-mfp-src');
    },
    open: function () {
      // カスタムクローズボタンを追加
      let closeBtn = $('<button class="custom-close-btn"><span></span><span></span></button>');
      this.contentContainer.append(closeBtn);

      closeBtn.on('click', function () {
        $.magnificPopup.close();
      });
    },
    beforeClose: function () {
      // クローズボタンを削除
      $('.custom-close-btn').remove();
    }
  },
  iframe: {
    patterns: {
      video: {
        index: '',
        src: '%id%' // URLをそのまま使用
      }
    },
    markup: '<div class="mfp-iframe-scaler">' +
      '<div class="mfp-close"></div>' +
      '<video class="mfp-iframe" controls autoplay>' +
      '<source src="%src%" type="video/mp4">' +
      '</video>' +
      '</div>'
  }
});
